// @flow
import type {
  ImageFile,
  Crop,
  RootState,
  FluxStandardAction,
  CurrentIcon,
} from '../../types'
import { ActionRequiresPropertyError } from '../../helpers'

// Constants

export const ICON_SET_FILE = 'ICON_SET_FILE'
export const ICON_SET_BLOB = 'ICON_SET_BLOB'
export const ICON_SET_CROP = 'ICON_SET_CROP'
export const ICON_CLEAR_CURRENT = 'ICON_CLEAR_CURRENT'

// Action creators

export const clearCurrentIcon = () => {
  return {
    type: ICON_CLEAR_CURRENT,
  }
}

export const setIconFile = (file: ImageFile) => {
  return {
    type: ICON_SET_FILE,
    payload: {
      file,
    },
  }
}

export const setIconBlob = (blob: any) => {
  return {
    type: ICON_SET_BLOB,
    payload: {
      blob,
    },
  }
}

export const setIconCrop = (crop: Crop) => {
  return {
    type: ICON_SET_CROP,
    payload: {
      crop,
    },
  }
}

// Selectors

export function getCurrentIcon(state: RootState) {
  return state.icons.current
}

export function getIconFile(state: RootState) {
  return state.icons.current.file
}

export function getIconBlob(state: RootState) {
  return state.icons.current.blob
}

export function getIconCrop(state: RootState) {
  return state.icons.current.crop
}

// Reducer

const initialState = {
  crop: null,
  file: null,
  blob: null,
}

export default function reducer(
  state: CurrentIcon = initialState,
  { type, payload }: FluxStandardAction
) {
  switch (type) {
    case ICON_SET_CROP:
      if (!payload || !payload.crop) {
        throw new ActionRequiresPropertyError(ICON_SET_CROP, 'payload.crop')
      } else {
        return {
          ...state,
          crop: payload.crop,
        }
      }
    case ICON_SET_BLOB:
      if (!payload || !payload.blob) {
        throw new ActionRequiresPropertyError(ICON_SET_BLOB, 'payload.blob')
      } else {
        return {
          ...state,
          blob: payload.blob,
        }
      }
    case ICON_SET_FILE:
      if (!payload || !payload.file) {
        throw new ActionRequiresPropertyError(ICON_SET_FILE, 'payload.file')
      } else {
        return {
          ...state,
          file: payload.file,
        }
      }
    case ICON_CLEAR_CURRENT:
      return initialState
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/stores/icons/current.js